module.exports = __webpack_public_path__ + "static/pillar-of-hope-0d6f8f4fe05b21510a95dec9654e9bcf.jpg";